import { render, staticRenderFns } from "./CommunicationItem.vue?vue&type=template&id=5ffcc76e&scoped=true&"
import script from "./CommunicationItem.vue?vue&type=script&lang=js&"
export * from "./CommunicationItem.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationItem.vue?vue&type=style&index=0&id=5ffcc76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcc76e",
  null
  
)

export default component.exports